<template>
    <div>
        <!-- BOTAO NOVO PERIODO -->
        <v-row>
            <modal-gdb :code="modal_code"
                :dialog-width="$vuetify.display.mdAndUp ? '60%': '100%'"
                toolbar-title="Vínculo Período/Questionários"
                :ref="modal_code"
                @on-toggle="onToggle">
                <template v-slot:activate-slot>
                    <slot name="modal-activate">
                        <v-btn>Vincular Período/Questionário</v-btn>
                    </slot>
                </template>
                <template v-slot:body>
                    <h2 class="mb-3">Período Questionário</h2>
                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-select v-model="selectedPeriodo"
                                :items="$store.state.rh.periodos"
                                :loading="$store.state.rh.periodos_loading"
                                return-object
                                item-value="id"
                                :item-title="v => v.descricao || 'Selecione Período...'"
                                no-data-text="Nenhum período"
                                label="Período"
                                >
                                <template v-slot:append>
                                    <!-- Form criação-->
                                    <FormPeriodoQuests>
                                        <template v-slot:modal-activate>
                                            <v-btn-small title="Criar novo período">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn-small>
                                        </template>
                                    </FormPeriodoQuests>
                                    <!-- Form alteração-->
                                    <FormPeriodoQuests v-if="!!selectedPeriodo && !!selectedPeriodo.id"
                                        :item="selectedPeriodo">
                                        <template v-slot:modal-activate>
                                            <v-btn-small :title="'Alterar período '+ selectedPeriodo.descricao">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn-small>
                                        </template>
                                    </FormPeriodoQuests>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-select
                                density="default"
                                v-model="selectedQuestionario"
                                :items="$store.state.rh.questionarios"
                                :loading="$store.state.rh.questionarios_loading"
                                return-object
                                item-value="id"
                                :item-title="v => v.titulo || 'Selecione questionário...'"
                                label="Questionário"
                                >
                                <template v-slot:selection="data">
                                    <!-- Quando item está selecionado no input v-select  -->
                                    <span v-html="data.item.raw.titulo"></span>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="!(typeof(data.item.raw) == 'object')">
                                        <v-list-item-title>-- {{data.item.raw}}</v-list-item-title>
                                        {{data.item.raw}}
                                    </template>
                                    <template v-else>
                                        <v-list-item v-bind="{...data.props, ...props }"
                                            color="primary" :title="''"
                                            >
                                            <v-list-item-title>
                                                <div>
                                                    <span v-html="data.item.raw.titulo"></span>
                                                </div>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </template>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </template>
                <template #actions>
                    <v-btn variant="flat"
                        @click="savePeriodoQuest({
                        periodo: selectedPeriodo.id,
                        questionario: selectedQuestionario.id
                    })">Salvar</v-btn>

                </template>
            </modal-gdb>

            <v-spacer></v-spacer>
            <v-btn-small icon @click="get_periodo_quests" :loading="$store.state.rh.periodoquests_loading">
                <v-icon>mdi-refresh</v-icon>
            </v-btn-small>
        </v-row>
        <v-divider class="my-2"></v-divider>
        <div v-for="per in Array.from(new Set(computedPeriodoQuests.map(i => i.periodo_object.descricao)))"
            :key="per.id" class="mb-4">
            
            <div class="text-h5">{{per}}</div>

            <div v-for="q, ind in computedPeriodoQuests.filter(i => i.periodo_object.descricao == per)"
                :key="ind">
                <modal-gdb :code="'modal_code_quest_'+ind"
                    dialog-width="100%"
                    :toolbar-title="q.periodo_object.descricao">
                    <template v-slot:activate-slot>
                        <slot name="modal-activate">
                            <v-btn style="width:100%" class="my-1">
                                <span v-html="q.questionario_object.titulo"></span>
                            </v-btn>
                        </slot>
                    </template>

                    <template v-slot:body>
                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn  color="error" title="Remover"
                                @click="deletePeriodo(q)">
                                <v-icon small >mdi-delete</v-icon>
                                Remover Período
                            </v-btn> 
                        </v-row>
                        <v-divider class="my-2"></v-divider>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <div><b>Título: </b><span v-html="q.questionario_object.titulo"></span></div>
                                <div><b>Nº Questões: </b>{{q.questionario_object.questoes.length}}</div>
                                <div><b>Per. aplicação: </b>{{$verify.formatarDataShort(q.periodo_object.inicio)}} à {{$verify.formatarDataShort(q.periodo_object.fim)}}</div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div>Competências avaliadas:
                                    <div v-for="c, i in Array.from(new Set(q.questionario_object.questoes.map(q => q.competencia.nome)))" :key="'c_'+i">
                                        - {{c}}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider class="my-2"></v-divider>
                        <v-row>
                            <small class="overline">Criado em: {{$verify.formatarData(q.created_at)}}</small>
                            <v-spacer></v-spacer>
                            <small><samp class="text-grey">{{q.id}}</samp></small>
                        </v-row>
                
                    </template>
                </modal-gdb>
            </div>

        </div>
    </div>
</template>
<script>
import PeriodoQuestFormValidation from './../../validations/forms/rh/formPeriodoQuest'
import FormPeriodoQuests from '@/components/rh/periodos/Form'
const formPeriodoQuestValidation = new PeriodoQuestFormValidation()
export default {
    components: {
        FormPeriodoQuests,
    },
    data: () => ({
        selectedPeriodo: {},
        selectedQuestionario: {},
        modal_code: 'modal_rh_periodo_questionario',
        expansible: null,
        payload: {
            periodo: null,
            questionario: null,
        }
    }),
    methods: {
        async get_periodo_quests(){
            await this.$store.dispatch('GetRHPeriodoQuests')
        },
        async get_periodos(){
            this.$store.dispatch('GetRHPeriodos')
        },
        async get_questionarios(){
            await this.$store.dispatch('GetRHQuestionarios')
        },
        formValidate(data){
            return formPeriodoQuestValidation.validate(data)
        },
        savePeriodoQuest(data){
            if (!this.formValidate(data)) return
            this.createPeriodoQuest(data)
        },
        async createPeriodoQuest(data){
            const created = await this.$store.dispatch('CreateRHPeriodoQuest', data)
            if(!created) return
            this.closeFormModal()
        },
        init () {
            this.get_periodos()
            this.get_questionarios()
            this.get_periodo_quests()
        },
        closeFormModal(){
            this.$refs[this.modal_code].dialog = false
        },
        async deletePeriodo(q){
            const conf = confirm('Tem certeza que deseja remover o período? Todos os questionários respondidos, vinculados a este Período/Questionário também serão removidos')
            if (!conf) return
            const deleted = await this.$store.dispatch('DeleteRHPeriodoQuest', q)
            if(deleted){
                this.closeFormModal()
            }
        },
        onToggle(value){
            if(value){
                this.selectedPeriodo = {}
                this.selectedQuestionario = {}
            }
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        computedPeriodoQuests(){
            return this.$store.state.rh.periodoquests
        }
    }
}
</script>